module.exports = __webpack_public_path__ + "fonts/Roboto-500.1d659482.woff";